import { createContext, JSX } from "solid-js";

import Country from "@repo/utils/Country";
import GoogleMaps from "@repo/utils-client/external/GoogleMaps";
import USolid from "@repo/utils-solid/USolid";

export * as Place from "./Place";
export { default as Map } from "./Map";

const Context = createContext<
  Omit<Provider.Props, "children"> & {
    load(): ReturnType<typeof GoogleMaps.load>;
  }
>();

export declare namespace Provider {
  type Props = {
    key: string;
    regionCodes: (Country | (string & {}))[];
    children: JSX.Element;
  };
}

export function Provider({ key, regionCodes, children }: D<Provider.Props>) {
  return (
    <Context.Provider
      value={{ load: () => GoogleMaps.load(key), key, regionCodes }}
    >
      {children}
    </Context.Provider>
  );
}

export function useContext() {
  const context = USolid.useContext(Context);

  if (!context)
    throw new Error(
      "Cannot call GoogleMaps.useContext outside of GoogleMapsSolid.Provider."
    );

  return context;
}
